import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class ReporteGastoService extends BaseAPIClass {
  baseUrl = '';
  public isLoading = false;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = this.baseUrl + '/reporte';
  }
  gastoReporte(object: any) {
    return this.httpClient.post(this.baseUrl + '/gastos', object);
  }

  gastoReporteCobranza(object: any) {
    return this.httpClient.post(this.baseUrl + '/cobranza', object);
  }


}
